import Api from "./Base";

export function updateNotification(id) {
    return Api.post(`/notifications/${id}/update`);
}

export function deleteNotification(id) {
    return Api.post(`/notifications/${id}/delete`);
}
